'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function wrapValidator(validator, typeName) {
  var typeChecker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return Object.assign(validator.bind(), {
    typeName: typeName,
    typeChecker: typeChecker,
    isRequired: Object.assign(validator.isRequired.bind(), {
      typeName: typeName,
      typeChecker: typeChecker,
      typeRequired: true
    })
  });
}

function RecordPropType(recordTypeName) {
  if (typeof recordTypeName !== 'string') {
    throw new TypeError('a string is required for the RecordPropType');
  }

  var validator = function recordIsType(props, propName, componentName) {
    var propValue = props[propName];

    if (propValue == null) {
      return null;
    }
    var propValueName = propValue._name;
    if (!propValueName) {
      return new Error('Invalid prop `' + propName + '` of type `' + (typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue)) + '` supplied to `' + componentName + '`. Expected Record of type `' + recordTypeName + '`');
    }
    if (propValueName !== recordTypeName) {
      return new Error('Invalid Record prop `' + propName + '` of type `' + propValueName + '` supplied to `' + componentName + '`. Expected `' + recordTypeName + '`');
    }

    return null;
  };

  validator.isRequired = function requiredRecordIsType(props, propName, componentName) {
    var propValue = props[propName];
    if (!propValue) {
      return new Error('Required ' + propName + ' was not specified in ' + componentName);
    }
    return validator(props, propName, componentName);
  };

  return wrapValidator(validator, 'recordIsType: ' + recordTypeName);
}

exports.default = RecordPropType;
module.exports = exports['default'];